import { IS_EMBEDDED } from 'utils/queryParamHelpers';

import { useExplat } from './useExplat';
import { baseEligibilityCheck } from './utils';

const EXPERIMENT_NAME = 'enrollment_new_application_experiment';

export function useNewAppExperiment(
  { skipLogging = false, useAnonymousID = true } = {
    skipLogging: false,
    useAnonymousID: true,
  }
) {
  const isEligible = baseEligibilityCheck();

  const { variant, isLoaded } = useExplat(EXPERIMENT_NAME, {
    isEligible: isEligible && !IS_EMBEDDED,
    skipLogging,
    useAnonymousID,
  });

  return {
    isLoaded,
    isControl: variant === 'control' || !variant,
    isTreatment: variant === 'treatment',
  };
}
